import {IModelBase, ModelBase} from "../../_modules/company/x-models/model-base";
import {State} from "../../enums/employee-event-state";

export class EmployeeEventResponseNl extends ModelBase implements IModelBase {
  comments: string = "";

  new: State = State.New;
  // @ts-ignore
  active: boolean | undefined;

  constructor(n: State) {
    super();
    this.new = n;
    this.active = undefined!;
  }
}
